<template>
  <div class="teaching-evaluate-apply-switch">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    width="320px"
                    title="切换方案"
                    custom-class="teaching-evaluate-apply-switch-dialog"
                    @open="handleReset">
      <div class="switch-main">
        <div class="main-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <template v-if="evaluations && evaluations.length">
            <el-radio-group v-model="form.id">
              <el-radio v-for="evaluation in evaluations"
                        :key="evaluation.id"
                        :label="evaluation.id"
                        border>
                <span>{{evaluation.name}}</span>
              </el-radio>
            </el-radio-group>
          </template>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交保存</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">取消操作</el-button>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'TeachingEvaluateApplySwitch',
  components: {
    DataGridDialog
  },
  props: {
    evaluations: Array
  },
  data () {
    return {
      visible: false,
      form: {
        id: ''
      },
      committing: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleApply () {
      if (!this.form.id) {
        this.$message.warning('请选择方案')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/plan/switch',
        method: 'post',
        data: this.$qs.stringify(this.form)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.handleClose()
              this.$nextTick(() => {
                this.$emit('switch-success')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    },
    handleReset () {
      let evaluations = this.evaluations
      if (evaluations) {
        let getActive = evaluations.find(evaluation => evaluation.active)
        if (getActive) {
          this.form.id = getActive.id
        } else {
          this.form.id = ''
        }
      } else {
        this.form.id = ''
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-switch {
    display: inline-block;
  }
  .teaching-evaluate-apply-switch-dialog {
    .switch-main {
      & > .main-cont {
        padding: 20px 15px;
        .el-radio-group {
          width: 100%;
          .el-radio {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row-reverse;
            background-color: #fff;
            border-radius: 20px;
            padding: 5px 15px;
            margin-right: 0;
            .el-radio__input {
              margin-top: 1px;
              margin-left: 10px;
            }
            .el-radio__label {
              display: inline-block;
              padding-left: 0;
              white-space: normal;
              line-height: 18px;
            }
            & + .el-radio {
              margin-left: 0;
              margin-top: 15px;
            }
          }
        }
      }
      & > .footer {
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
